import React from 'react';

const ColorButton = ({ color, selected, onClick, darkMode }) => (
    <button
        onClick={onClick}
        className={`
            w-full aspect-square rounded-xl transition-all duration-200 ease-out
            border-2 transform hover:scale-110 hover:rotate-3
            ${selected
                ? darkMode
                    ? 'border-violet-400 ring-2 ring-violet-500/50 shadow-lg shadow-violet-500/20 scale-110'
                    : 'border-blue-500 ring-2 ring-blue-400/50 shadow-lg shadow-blue-500/20 scale-110'
                : 'border-transparent hover:border-white/50'
            }
        `}
        style={{
            backgroundColor: color,
            boxShadow: selected ? `0 4px 15px ${color}40` : 'none'
        }}
    />
);

export default ColorButton;
